var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"button main",class:{TA: _vm.isTestAchat},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n"+_vm._s(_vm.getLabel)+"\n"),(_vm.isLoading)?_c('SvgIcon',{staticClass:"loading",attrs:{"icon":"loading"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494b777e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextButton.vue
// module id = null
// module chunks = 